import React, {createRef} from 'react';
import clsx from "clsx";

export default function Date(props) {

    const labelRef = createRef();
    const sublabelRef = createRef();

    const data = props.data;
    const updateFormData = props.updateFormData;

    return <div id={data.id} className={clsx("sendiio-form-date-element", `sendiio-form-label-alignment-${data.labelAlignment}`)}>
        <label ref={labelRef}
               className={clsx("sendiio-form-date-label cursor-text", data.required && 'sendiio-form-element-required')}
               format="text"
               contentEditable={true}
               suppressContentEditableWarning={true}
               onBlur={e => {

                   if(data.label !== e.currentTarget.textContent){

                       data.label = e.currentTarget.textContent;

                       updateFormData(data);

                       labelRef.current.textContent = e.currentTarget.textContent;

                   }

               }}
               dangerouslySetInnerHTML={{__html: data.label}} />
        <div className="sendiio-form-element-wrapper">
            <span className="sendiio-form-date-input-wrapper">
                <input className="sendiio-form-date-input cursor-text"
                       type="text"
                       placeholder={data.placeholder}
                       onChange={e => {e.preventDefault()}}
                       id={`input-${data.id}-date`}
                       name={`${data.id}-date`}
                       value="" />
                <span className="sendiio-form-date-input-icon" />
            </span>
            <p  ref={sublabelRef}
                className="sendiio-form-date-sublabel cursor-text"
                format="text"
                contentEditable={true}
                suppressContentEditableWarning={true}
                onBlur={e => {

                    if(data.sublabel !== e.currentTarget.textContent){

                        data.sublabel = e.currentTarget.textContent;

                        updateFormData(data);

                        sublabelRef.current.textContent = e.currentTarget.textContent;

                    }

                }}
                dangerouslySetInnerHTML={{__html: data.sublabel}} />
        </div>
    </div>

}